import { ProductSlider } from "@repo/components";
import { getRelatedProducts } from "@repo/server-actions/product";
import { getTranslations } from "next-intl/server";
const RelatedProducts = async ({
  itemId,
  wishlistItems,
  session,
  locale
}) => {
  const t = await getTranslations("Common");
  const products = await getRelatedProducts(itemId, locale);
  if (!products.length) return;
  return <div className="mx-auto md:max-w-screen-xl" data-sentry-component="RelatedProducts" data-sentry-source-file="RelatedProducts.jsx">
      <ProductSlider title={t("Related_Products")} items={products} wishlistItems={wishlistItems} type="Related Products" isMedium session={session} data-sentry-element="ProductSlider" data-sentry-source-file="RelatedProducts.jsx" />
    </div>;
};
export default RelatedProducts;